import { Navigate, RouteObject } from "react-router";
import OrdersRoute from "@/routes/processes/[processId]/vbs/orders/orders-route";
import { OrderRoute } from "@/routes/processes/[processId]/vbs/orders/[orderId]/order-route";
import { OrderDataRoute } from "@/routes/processes/[processId]/vbs/orders/[orderId]/data/order-data-route";
import { OrderTreatmentRoute } from "@/routes/processes/[processId]/vbs/orders/[orderId]/treatment/order-treatment-route";
import { AddressesAndContactsRoute } from "@/routes/processes/[processId]/vbs/orders/[orderId]/addresses-and-contacts/addresses-and-contacts-route";
import { OrderFilesRoute } from "@/routes/processes/[processId]/vbs/orders/[orderId]/files/order-files-route";

export const vbsOrdersRoutes: RouteObject[] = [
  {
    index: true,
    element: <OrdersRoute />,
  },
  {
    path: ":orderId",
    element: <OrderRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="data" replace />,
      },
      {
        path: "data",
        element: <OrderDataRoute />,
      },
      {
        path: "treatment",
        element: <OrderTreatmentRoute />,
      },
      {
        path: "addresses-and-contacts",
        element: <AddressesAndContactsRoute />,
      },
      {
        path: "files",
        element: <OrderFilesRoute />,
      },
    ],
  },
];
